//
//  FitinsightUserList.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { ReactElement } from "react";
import { Container, CircularProgress, Box } from "@mui/material";
import IsnLogo from "./component/IsnLogo";
import FitinsightUserTable from "./component/FitinsightUserTable";
import { PageTitle } from "./component/PageTitle";
import UserCountDisplay from "./component/UserCountDisplay";
import useFitinsightUserList from "./hooks/useFitinsightUserList";
import DownloadCSV from "./component/FitinsightUserCsv";
import BackToAdminButton from "./component/BackToAminMainButton";
import TitleBar from "./component/TitleBar";
import { CONTACT_URL } from "./utils/env";

const FitinsightUserList = (): ReactElement => {
  const {
    filterList,
    activeFilters,
    originalUserCount,
    filteredUserCount,
    displayedUsers,
    showProgress,
    rowsPerPage,
    page,
    checkedAll,
    handleChecked,
    handlePageChange,
  } = useFitinsightUserList();

  return (
    <>
      <TitleBar contactUrl={CONTACT_URL} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          width: "100%",
          padding: "10px 0",
        }}
      >
        <BackToAdminButton />
      </Box>
      
      <Container
        sx={{
          my: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <PageTitle title="連携済みユーザ一覧" />
        <Container
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 3,
          }}
        >
          <UserCountDisplay label="合計" count={originalUserCount} />
          <UserCountDisplay label="絞り込み合計" count={filteredUserCount} />
          <DownloadCSV />
        </Container>
        {showProgress ? (
          <CircularProgress sx={{ m: 5 }} />
        ) : (
          <FitinsightUserTable
            allFilters={filterList}
            checkedFilters={activeFilters}
            users={displayedUsers}
            userCount={filteredUserCount}
            rowsPerPage={rowsPerPage}
            page={page}
            checkedAll={checkedAll}
            handleChecked={handleChecked}
            hadlePageChange={handlePageChange}
          />
        )}
      </Container>
    </>
  );
};

export default FitinsightUserList;
